import request from '@/utils/request'
import { setStorage, getStorage } from '@/utils/auth'

const state = {
  userInfo: {},
  corpId: getStorage('corpId'),
  agentId: getStorage('agentId'),
  deptId: '',
  projectList: [],
  costType: [],
  assetTypeList: [],
  userProjectList: [],
  userProjectListLevel1: [],
  yearList: [],
  monthList: [],
}
const mutations = {
  SET_CORPID: (state, data) => {
    state.corpId = data
    setStorage('corpId', data)
  },
  SET_AGENTID: (state, data) => {
    state.agentId = data
    setStorage('agentId', data)
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_DEPTID: (state, deptId) => {
    state.deptId = deptId
  },
  SET_PROJECTLIST: (state, projectList) => {
    state.projectList = projectList
  },
  SET_COSTTYPE: (state, costType) => {
    state.costType = costType
  },
  SET_ASSETTYPE: (state, assetTypeList) => {
    state.assetTypeList = assetTypeList
  },
  SET_USERPROJECTLIST: (state, userProjectList) => {
    state.userProjectList = userProjectList
  },
  SET_USERPROJECTLISTLEVEL1: (state, userProjectListLevel1) => {
    state.userProjectListLevel1 = userProjectListLevel1
  },
  SET_YEARLIST: (state, yearList) => {
    state.yearList = yearList
  },
  SET_MONTHLIST: (state, monthList) => {
    state.monthList = monthList
  },
}
const actions = {
  getProjectList({ commit, state }) {
    if (state.projectList.length > 0) {
      return;
    }
    request
    .get('/api/project/queryAll')
    .then(res => {
      if ( res.success) {
        commit("SET_PROJECTLIST", res.data);
      }
    });
  },
  getUserProjectList({ commit, state, dispatch }) {
    if (state.userProjectList.length > 0) {
      return;
    }
    dispatch('updateUserProjectList')
  },
  updateUserProjectList({ commit, state }) {
    request
    .get('/api/project/userDeptAndProject')
    .then(res => {
      if ( res.success) {
        commit("SET_USERPROJECTLIST", res.data.projectList);
      }
    });
  },
  getUserProjectListLevel1({ commit, state, dispatch }) {
    if (state.userProjectListLevel1.length > 0) {
      return;
    }
    dispatch('updateUserProjectListLevel1')
  },
  updateUserProjectListLevel1({ commit, state }) {
    var params = {
      level: 1
    }
    request
    .get('/api/project/userDeptAndProject', {params})
    .then(res => {
      if ( res.success) {
        commit("SET_USERPROJECTLISTLEVEL1", res.data.projectList);
      }
    });
  },
  getCostType({ commit, state, dispatch }) {
    if (state.costType.length > 0) {
      return;
    }
    dispatch('updateCostType')
  },
  updateCostType({ commit, state }) {
    request
    .get('/api/costType/all')
    .then(res => {
      if ( res.success) {
        commit("SET_COSTTYPE", res.data);
      }
    });
  },
  getAssetType({ commit, state, dispatch }) {
    if (state.assetTypeList.length > 0) {
      return;
    }
    dispatch('updateAssetType')
  },
  updateAssetType({ commit, state }) {
    return request
    .get('/api/assetType')
    .then(res => {
      if ( res.success) {
        commit("SET_ASSETTYPE", res.data || []);
      }
    });
  },
  getYearList({ commit, state, dispatch }) {
    if (state.yearList.length > 0) {
      return;
    }
    // 获取当前时间，年份
    var now = new Date();
    var yearList = [];
    for(var i = now.getFullYear() - 2; i <= now.getFullYear() + 2; i++) {
      yearList.push(i);
    }
    commit("SET_YEARLIST", yearList);
  },
  getMonthList({ commit, state, dispatch }) {
    if (state.monthList.length > 0) {
      return;
    }
    var monthList = [];
    for(var i = 1; i <= 12; i++) {
      monthList.push(i);
    }
    commit("SET_MONTHLIST", monthList);
  }
}
function saveData(type, data) {
  localStorage.setItem(type, JSON.stringify(data))
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
